export default __webpack_public_path__ + "static/media/whoops-bell.344a95ef.svg";